<dgx-tag-rating-checkup-tip
  [@dfCollapseExpand]
  *ngIf="hasSkillsCheckup && isOwner"
  class="grid__col-12 guts-p-v-0"
  [tags]="tags"
  (dismiss)="doneRating()"
></dgx-tag-rating-checkup-tip>

<div class="grid">
  <ng-container *dgxFeatureToggle="'skill-standards-learner-view'">
    <div
      class="grid__col-12 grid__col--bleed guts-p-t-2"
      *ngIf="!skillsLoading && skillStandards.length"
    >
      <!-- Skill Standards -->
      <div class="grid__col-12 guts-p-v-0">
        <h1 class="h3">{{ 'SkillStd_SkillStandards' | translate }}</h1>
        <p class="zeta par--light">
          {{ 'SkillStd_SkillStandardsProfileSectionSubtitle' | translate }}
        </p>
      </div>

      <ul class="grid">
        <li
          *ngFor="let skillStandard of skillStandards"
          class="grid__col-xs-12 grid__col-md-4"
          data-dgat="profile-skills-472"
        >
          <dgx-skill-standards-card
            [skillStandard]="skillStandard"
          ></dgx-skill-standards-card>
        </li>
      </ul>
    </div>
  </ng-container>
</div>

<div class="grid center-item l_flex-column">
  <dgx-profile-filter-bar
    (filterUpdated)="applyFilter($event)"
    [filter]="activeFilter"
    [includeDefaultFilters]="true"
    [placeholder]="i18n.dgProfileOverview_FilterForSkills"
  >
    <div class="l_flex--inline">
      <dgx-column-configurator
        *ngIf="
          selectedLayoutId === 'list' &&
          !isMobile &&
          !!columnConfigurations &&
          !!availableColumns
        "
        [columnConfigurations]="columnConfigurations"
        [preferredColumnConfigurations]="preferredColumnConfigurations"
        [availableColumns]="availableColumns"
        [maxSelectable]="MAX_SELECTABLE_COLUMNS"
        [typeDefaultHierarchy]="PROFILE_SKILLS_TABLE_DEFAULT_HIERARCHY"
        [useMediaListener]="true"
        (onChange)="updateListColumns($event)"
      ></dgx-column-configurator>
      <h4 *ngIf="showViewRatingScaleButton">
        <button
          type="button"
          class="h4 par par--small font-semibold color-blue guts-m-v-1 guts-m-r-1"
          (click)="
            openAnnouncementModalOnLoad(
              skillScaleLevelChangeModalTypes.ORG_RATING_SCALE_CHANGE
            )
          "
          data-dgat="profile-skills-fcb">
          <span class="ib-v-middle no-wrap">
            {{ 'dgTagRating_ViewRatingScale' | translate }}</span
          >
        </button>
      </h4>

      <dgx-pill-selector
        *ngIf="!isMobile"
        class="guts-m-r-1"
        [options]="layoutOptions"
        [selectedId]="selectedLayoutId"
        (select)="changeLayout($event)"
      ></dgx-pill-selector>
      <button
        *ngIf="isOwner"
        class="no-wrap"
        df-button
        dfButtonType="primary"
        (click)="addSkill($event)"
        data-dgat="profile-skills-299"
      >
        <div class="l_flexbar gap-full-half">
          <df-icon icon="plus"></df-icon>
          <div>{{ i18n.dgProfileOverview_AddSkillOrTopic }}</div>
        </div>
      </button>
    </div>
  </dgx-profile-filter-bar>

  <div [ngSwitch]="selectedLayoutId">
    <!-- Grid layout -->
    <div *ngSwitchCase="'grid'">
      <!-- Sorted Skills -->
      <div class="spinner" *ngIf="!sortedTags"></div>

      <!-- All skills -->
      <div [hidden]="showSearchResults" *ngIf="sortedTags" class="full-width">
        <ng-container
          *dgxFeatureToggle="
            ['isSkillInventoryClient', 'isSkillAnalyticsClient'];
            hidden: true
          "
        >
          <div
            [hidden]="!showFocusSkills"
            class="grid__col-12 grid__col--bleed guts-p-t-2"
          >
            <!-- Focus skills -->
            <div class="grid__col-12 guts-p-v-0">
              <h1 class="h3">
                {{ i18n.dgProfileOverview_FocusSkills }}
              </h1>
              <p class="zeta par--light">
                {{ focusSkillDescriptionText }}
                <b class="body-text" *ngIf="maxFocusSkillText">{{
                    maxFocusSkillText
                  }}</b>
              </p>
            </div>
            <ul
              class="grid"
              #focusSkillContainer
              data-dgprop-render-method="Profile Skills Grid"
            >
              <li
                *ngFor="let tag of sortedTags.focus"
                class="grid__col-xs-6 grid__col-sm-4 grid__col-lg-3"
                data-dgat="profile-skills-851"
              >
                <dgx-tag-tile
                  class="block"
                  [tag]="tag"
                  [targetLevel]="tagRatingService.getSkillTarget(tag)"
                  [actionsContext]="tag"
                  [isOwner]="isOwner"
                  [showUpdateLink]="hasSkillsCheckup"
                >
                </dgx-tag-tile>
              </li>
              <ng-container
                *ngIf="focusSkillsNeedStubs(sortedTags.focus.length)"
              >
                <li
                  *ngFor="
                    let stub of getStubArray(sortedTags.focus.length, true);
                    let tileIdx = index;
                    trackBy: trackByFn
                  "
                  class="grid__col-xs-6 grid__col-sm-4 grid__col-lg-3"
                  data-dgat="profile-skills-513"
                  [attr.data-dgprop-item-clicked]="
                    shouldShowFocusTileDescription(
                      sortedTags.focus.length,
                      tileIdx
                    )
                      ? 'Stub With Details'
                      : 'Stub'
                  "
                >
                  <div
                    class="tile tile--stub tile--tag focus-skill-placeholder guts-p-h-2"
                  >
                    <div
                      *ngIf="
                        shouldShowFocusTileDescription(
                          sortedTags.focus.length,
                          tileIdx
                        )
                      "
                      class="abs-center par--light"
                    >
                      <df-icon
                        icon="question-mark-circle"
                        class="v-baseline horizontal-center"
                      ></df-icon>
                      <p class="zeta center-text" [innerHtml]="helpText"></p>
                    </div>
                  </div>
                </li>
              </ng-container>
            </ul>
          </div>
        </ng-container>
        <!-- Required skills -->
        <div
          [hidden]="!showRequiredSkills"
          class="grid__col-12 grid__col--bleed guts-p-t-2"
        >
          <div class="grid__col-12 guts-p-v-0">
            <h1 class="h3">
              {{ requiredSkillsHeading }}
            </h1>
            <p class="zeta par--light">
              {{ requiredSkillDescriptionText }}
            </p>
          </div>
          <ul
            class="grid"
            #additionalSkillContainer
            data-dgprop-render-method="Profile Skills Grid"
          >
            <ng-container
              *ngFor="
                let chunk of sortedTags.required | chunked: 8;
                index as idx
              "
              data-dgat="profile-skills-650"
            >
              <li
                dgxIntersectionObserver
                (onIntersection)="renderChunk(idx)"
                [options]="{ threshold: 0.5 }"
                role="presentation"
              ></li>
              <li
                *ngFor="let tag of chunk"
                class="grid__col-xs-6 grid__col-sm-4 grid__col-lg-3"
                data-dgat="Skills-2ca"
              >
                <dgx-tag-tile
                  *ngIf="chunkRendered[idx]; else loading"
                  class="block"
                  [tag]="tag"
                  [targetLevel]="tagRatingService.getSkillTarget(tag)"
                  [actionsContext]="tag"
                  [isOwner]="isOwner"
                  [showUpdateLink]="hasSkillsCheckup"
                >
                </dgx-tag-tile>
                <ng-template #loading>
                  <div class="tile tile--stub"></div>
                </ng-template>
              </li>
            </ng-container>
            <ng-container *ngIf="needStubs(sortedTags.required.length)">
              <li
                *ngFor="
                  let stub of getStubArray(sortedTags.required.length);
                  trackBy: trackByFn
                "
                class="grid__col-xs-6 grid__col-sm-4 grid__col-lg-3"
                data-dgat="Skills-7b2"
              >
                <div class="tile tile--stub tile--tag"></div>
              </li>
            </ng-container>
          </ul>
        </div>
        <!-- Additional skills -->
        <div class="grid__col-12 grid__col--bleed guts-p-t-2">
          <h1
            *ngIf="
              sortedTags.other.length &&
              !(isSkillInventoryProfile || isSkillAnalyticsProfile) &&
              additionalSkillsHeading
            "
            class="h3 grid__col-12 guts-p-v-0"
          >
            {{ additionalSkillsHeading }}
          </h1>
          <ul
            class="grid"
            #additionalSkillContainer
            data-dgprop-render-method="Profile Skills Grid"
          >
            <ng-container
              *ngFor="let chunk of sortedTags.other | chunked: 8; index as idx"
              data-dgat="profile-skills-650"
            >
              <li
                dgxIntersectionObserver
                (onIntersection)="renderChunk(idx)"
                [options]="{ threshold: 0.5 }"
                role="presentation"
              ></li>
              <li
                *ngFor="let tag of chunk"
                class="grid__col-xs-6 grid__col-sm-4 grid__col-lg-3"
                data-dgat="Skills-2ca"
              >
                <dgx-tag-tile
                  *ngIf="chunkRendered[idx]; else loading"
                  class="block"
                  [tag]="tag"
                  [targetLevel]="tagRatingService.getSkillTarget(tag)"
                  [actionsContext]="tag"
                  [isOwner]="isOwner"
                  [showUpdateLink]="hasSkillsCheckup"
                >
                </dgx-tag-tile>
                <ng-template #loading>
                  <div class="tile tile--stub"></div>
                </ng-template>
              </li>
            </ng-container>
            <ng-container *ngIf="needStubs(sortedTags.other.length)">
              <li
                *ngFor="
                  let stub of getStubArray(sortedTags.other.length);
                  trackBy: trackByFn
                "
                class="grid__col-xs-6 grid__col-sm-4 grid__col-lg-3"
                data-dgat="Skills-7b2"
              >
                <div class="tile tile--stub tile--tag"></div>
              </li>
            </ng-container>
          </ul>
        </div>
        <!-- No skills -->
        <div
          class="center-text guts-m-t-2 ls ws"
          *ngIf="
            !sortedTags.other.length && !sortedTags.focus.length && !isOwner
          "
        >
          <p class="gamma">
            {{ i18n.UserController_NoResults }}
          </p>
        </div>
      </div>

      <!-- filtered results -->
      <div class="center-text guts-m-t-2" *ngIf="showSearchResults">
        <ul class="grid" data-dgprop-render-method="Profile Skills Grid">
          <li
            *ngFor="let tag of tags"
            class="grid__col-xs-6 grid__col-sm-4 grid__col-lg-3"
            [hidden]="!tag.show"
            data-dgat="profile-skills-774"
          >
            <dgx-tag-tile
              class="block"
              [tag]="tag"
              [targetLevel]="tagRatingService.getSkillTarget(tag)"
              [actionsContext]="tag"
              [isOwner]="isOwner"
              [showUpdateLink]="hasSkillsCheckup"
            >
            </dgx-tag-tile>
          </li>
        </ul>
      </div>
    </div>

    <!-- List layout -->
    <div *ngSwitchCase="'list'" class="guts-m-t-2-half">
      <dgx-profile-skills-list
        [hidden]="!sortedTags || isSearchEmpty()"
        [tags]="tags"
        [isOwner]="isOwner"
        [owner]="owner"
        [visibleColumnTypes]="visibleColumnTypes"
        [filter]="filter"
        [showSignalsColumn]="showSignalsColumn"
        data-dgprop-render-method="Profile Skills List"
      ></dgx-profile-skills-list>
    </div>
  </div>
</div>

<!-- No search results -->
<div
  class="center-text guts-p-t-6"
  *ngIf="showSearchResults && isSearchEmpty()"
>
  <img
    *ngIf="noItemsImage"
    [alt]="i18n.Core_Empty_Image_Alt"
    [src]="noItemsImage"
    class="image-layout--empty"
  />
  <p class="guts-p-t-2" [textContent]="i18n.Core_NoResultsFor"></p>
</div>

<div class="footer-glasses"></div>
